import { createCookie, readCookie, removeCookie, } from '../modules/cookieHandler';
import { COOKIE_ACCESS_TOKEN } from '../constants';
export class WebTokenProvider {
    saveToken(token) {
        WebTokenProvider.token = token;
        createCookie(COOKIE_ACCESS_TOKEN, token, 180, '/');
    }
    getToken() {
        // First check in-memory token
        if (WebTokenProvider.token) {
            return WebTokenProvider.token;
        }
        // Fall back to cookie if in-memory token is not available
        const cookieToken = readCookie(COOKIE_ACCESS_TOKEN);
        if (cookieToken) {
            return cookieToken;
        }
        return null;
    }
    removeToken() {
        WebTokenProvider.token = null;
        removeCookie(COOKIE_ACCESS_TOKEN, '/');
    }
}
WebTokenProvider.token = null;
